import { z } from 'zod'

export const SearchTabQuerySchema = z.enum(['flights', 'hotels', 'carhire', 'experiences'])

export type SearchTabQuery = z.infer<typeof SearchTabQuerySchema>
